import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GrowthBook } from '@growthbook/growthbook';
import { thirdPartyTrackingPlugin, autoAttributesPlugin } from '@growthbook/growthbook/plugins';

@Injectable({
	providedIn: 'root',
})
export class GrowthBookService {
	private readonly growthbook: GrowthBook;

	private readonly isReadySubject = new BehaviorSubject<boolean>(false);
	public readonly isReady$: Observable<boolean> = this.isReadySubject.asObservable();

	constructor() {
		this.growthbook = new GrowthBook({
			apiHost: 'https://cdn.growthbook.io',
			clientKey: 'sdk-lmRgRICaN8YjmWzU',
			enableDevMode: true,
			plugins: [autoAttributesPlugin(), thirdPartyTrackingPlugin({ trackers: ['gtm'] })],
		});

		void this.initGrowthBook();
	}

	private async initGrowthBook(): Promise<void> {
		await this.growthbook.init({ streaming: true });
		this.isReadySubject.next(true);
	}

	isFeatureOn(featureKey: string): boolean {
		return this.growthbook.isOn(featureKey);
	}

	getFeatureValue<T>(featureKey: string, defaultValue: T): T {
		return this.growthbook.getFeatureValue(featureKey, defaultValue) as T;
	}

	getBooleanFeature(featureKey: string, defaultValue = false): boolean {
		return this.growthbook.getFeatureValue(featureKey, defaultValue) as boolean;
	}

	getStringFeature(featureKey: string, defaultValue = ''): string {
		return this.growthbook.getFeatureValue(featureKey, defaultValue) as string;
	}

	getNumberFeature(featureKey: string, defaultValue = 0): number {
		return this.growthbook.getFeatureValue(featureKey, defaultValue) as number;
	}

	getGrowthBookInstance(): GrowthBook {
		return this.growthbook;
	}
}
